import { DateRange as NulogyDateRange } from "@nulogy/components";
import { useField, useFormikContext } from "formik";
import React from "react";

const validateDateRange = ({ startDate, endDate }) => {
  if (!startDate || !endDate) return null;

  if (startDate > endDate) {
    return "End date is before start date";
  }

  return null;
};

export default function DateRange({
  onChange,
  field: name,
  defaultStartDate,
  startDateInputProps,
  endDateInputProps,
  showTimes,
}) {
  const { setFieldValue } = useFormikContext();
  const [_field, meta, helpers] = useField({ name, validate: validateDateRange });

  const handleRangeChange = (value) => {
    if (onChange) {
      onChange({ setFieldValue, value });
    }
    helpers.setValue(value);
  };

  return (
    <NulogyDateRange
      defaultStartDate={defaultStartDate}
      disableRangeValidation
      endDateInputProps={endDateInputProps}
      errorMessage={meta.error}
      labelProps={{ labelText: "" }}
      onRangeChange={handleRangeChange}
      showTimes={showTimes}
      startDateInputProps={startDateInputProps}
    />
  );
}
